import { lazy } from "react";

export const OfflineOrdersOverview = lazy(() =>
  import("./OrdersOverview/OrdersOverview")
);
export const OnlineOrdersOverview = lazy(() =>
  import("./OnlineOrdersOverview")
);
export const Projects = lazy(() => import("./Projects/Projects"));
export const CreateProject = lazy(() =>
  import("./CreateProject/CreateProject")
);
export const ProjectDetails = lazy(() =>
  import("./ProjectDetails/ProjectDetails")
);
export const Users = lazy(() => import("./Users/Users"));
export const Profile = lazy(() => import("./Profile/Profile"));
export const User = lazy(() => import("./User/User"));
export const EditUser = lazy(() => import("./EditUser/EditUser"));
export const OrderDetails = lazy(() => import("./OrderDetails/OrderDetails"));
export const Batches = lazy(() => import("./Batches/Batches"));
export const UnitsGroup = lazy(() => import("./UnitsGroup/UnitsGroup"));
export const Offers = lazy(() => import("./Offers/Offers"));
export const Order = lazy(() => import("./Order/Order"));
export const MapPage = lazy(() => import("./MapPage/MapPage"));
export const Parcels = lazy(() => import("./Parcels/Parcels"));
export const IntrestedList = lazy(() =>
  import("./IntrestedList/IntrestedList")
);
export const TransactionsTracker = lazy(() => import("./TransactionsTracker"));
export const Transactions = lazy(() => import("./Transactions"));
export const Application = lazy(() => import("./Application/Application"));
export const Admin = lazy(() => import("./Admin"));
export const Login = lazy(() => import("./Login/Login"));
export const Register = lazy(() => import("./Register"));
